import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../utils/tokenValidator';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = localStorage.getItem('token');

  // Debug: mostra no console (apenas em desenvolvimento)
  if (process.env.NODE_ENV === 'development') {
    console.log('[PrivateRoute] Token presente:', !!token);
  }

  // Verifica se o token existe e é válido (não expirado)
  if (!isTokenValid(token)) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[PrivateRoute] Redirecionando para /login - token inválido ou expirado');
    }

    // Limpa tokens inválidos do localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');

    return <Navigate to="/login" replace />;
  }

  // Se houver token válido, renderiza o conteúdo
  return <>{children}</>;
};